<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <h1>Felhasználó törlése</h1>
  </ng-template>

  <div>{{ data.email }}</div>
  <div>{{ data.user_name }}</div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading"
      (click)="submit()"
    >
      Törlés
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      mat-dialog-close
      [disabled]="loading"
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
